var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pagination"},[_c('el-pagination',{attrs:{"current-page":_vm.paginationData.page,"page-sizes":[20, 50, 100, 500, 1000],"page-size":_vm.paginationData['per-page'],"layout":_vm.layout,"total":_vm.paginationData.total,"small":_vm.small},on:{"size-change":_vm.handleSizeChange,"current-change":_vm.handleCurrentChange}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }